import React, { useEffect, useState } from 'react';
import { Form, Button, Alert, Spinner, Col, Row, Table } from 'react-bootstrap';
import { useNavigate, Link } from 'react-router-dom';
import { postData } from '../ApiServices/ApiService';
import AdminNavHeader from './AdminNavHeader';

const RegisteredCandidates = () => {
  const navigate = useNavigate();
  const aminInfo = JSON.parse(localStorage.getItem('admin-info'));
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  const [jobFlag, setJobFlag] = useState(true);
  const [jobList, setJobList] = useState([]);
  const [filteredData, setFilteredData] = useState(jobList);
  const [isCategory, setisCategory] = useState(false);

  const [searchData, setSearchData] = useState([])
  const handleSearch = async (e) => {
    console.log("filtered",filteredData)
    e.preventDefault();
    setSearchData(filteredData)
    console.log("name",e)
    if (searchTerm.trim() === '') {
      setFilteredData(filteredData);
    } else {
      const filteredJobs = filteredData.filter((job) => {
        // job.job_client.toLowerCase().includes(searchTerm.toLowerCase())
        const clientName = job && job.job_name && job.job_name?.toLowerCase();
       
        return clientName && clientName.includes(searchTerm?.toLowerCase());
      });
      setFilteredData(filteredJobs.length > 0 ? filteredJobs : filteredData);
    }
    
  };






  useEffect(() => {
    listOfJobs();
  }, [])

  const listOfJobs = async () => {
    
    setSuccess('')
    setSearchTerm('')
    setJobFlag(true)
    // e.preventDefault();
    setJobList([]);
    const payload = {
      // "company_id": aminInfo?.organization_id,
      "company_id": aminInfo?.organization_id,
      "user_id": aminInfo?.user_id

    }; 
    setLoading(true)
    // return
    try {
      await postData('admin_in/job/get-jobs-list', payload).then(resp => {
        resp.json().then(respData => {
          if (resp.status === 200) {
            if (respData.statusCode === 200) {
              if (respData.message.toLowerCase() === 'success') {
                setJobList(respData.dataJ);                
                setFilteredData(respData.dataJ);
                setLoading(false);
                if (respData.dataJ.length === 0) {
                  setSuccess("Created Jobs are not found")
                }
                //setSuccess(resp.info);
              } else {
                setLoading(false);
                setSuccess(respData.info);
              }

            } else if (respData.statusCode === 500) {
              setLoading(false);
              setSuccess(respData.info);
            } else {
              setLoading(false);
              setSuccess('Job Details failed. Please check your credentials.');
            }
          }
          else if (resp.status === 401 || resp.status === 403 || resp.status === 400) {
            setLoading(false);
            console.log('resp status else if : ', resp.status);
            if (respData.message === 'Unauthorized' || respData.message === 'The incoming token has expired'
              || respData.message === 'Access Denied') {

              //   callRefreshTokenApi('getSfeBatch', '');
            }
            setisCategory(false);
            setSuccess('Looks Like Session Expired Please login..');
          } else {
            console.log('resp status else  : ', resp);
            setLoading(false);
            setSuccess('Job Details failed. Please check your credentials!');
          }
        }).catch((error) => {
          console.log('network error:', error);
          setLoading(false);
          setSuccess('Job Details failed. Please check your credentials!!');

        });

      }).catch((error) => {
        setLoading(false);
        setSuccess('JobDetails failed. Please check your credentials or Network Error');
        console.log('network error:', error);

      });
    } catch (error) {
      setLoading(false);
      // Handle login error, e.g., display an error message to the user.
      console.error('Job Details failed', error);
    }
  }




  const [sortOrder, setSortOrder] = useState('asc');
  const [sortOrderById, setSortOrderById] = useState('asc');
  const [sortOrderClient,setSortOrderClient]=useState('asc')

  const toggleSortOrder = (sortedValue) => {
    if (sortedValue === 'jobname') {
      const newSortOrder = sortOrder === 'asc' ? 'desc' : 'asc';
      setSortOrder(newSortOrder);

      // Sort the data based on the current sort order
      const sorted = [...filteredData].sort((a, b) => {
        const nameA = a.job_name.toUpperCase();
        const nameB = b.job_name.toUpperCase();

        if (newSortOrder === 'asc') {
          return nameA.localeCompare(nameB);
        } else {
          return nameB.localeCompare(nameA);
        }
      });

      // setSortedData(sorted);
      setFilteredData(sorted);
    }else if(sortedValue === 'clientname'){
      const newSortOrder = sortOrderClient === 'asc' ? 'desc' : 'asc';
      setSortOrderClient(newSortOrder);

      // Sort the data based on the current sort order
      const sortedClient = [...filteredData].sort((a, b) => {
        const nameA = a.client_name.toUpperCase();
        const nameB = b.client_name.toUpperCase();

        if (newSortOrder === 'asc') {
          return nameA.localeCompare(nameB);
        } else {
          return nameB.localeCompare(nameA);
        }
      });

      // setSortedData(sorted);
      setFilteredData(sortedClient);
    }
     else {
      const newSortOrder = sortOrderById === 'asc' ? 'desc' : 'asc';
      setSortOrderById(newSortOrder);

      const sortedData = filteredData.sort((a, b) => {
        const compareResult = sortOrderById === 'asc' ? a.job_id.localeCompare(b.job_id) : b.job_id.localeCompare(a.job_id);
        return compareResult;
      });

      setFilteredData(sortedData);
    }



  };

  const [selectedPageCount, setSelectedPageCount] = useState(10);

  const handleJobsPerPage = (event) => {
    setSelectedPageCount(event.target.value);
    setCurrentPage(1)
  };

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = selectedPageCount; // Set the number of items per page

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const pageRange = 2; // Number of page buttons to show on each side of the current page

  const getPageRange = () => {
    const start = Math.max(1, currentPage - pageRange);
    const end = Math.min(totalPages, currentPage + pageRange);

    return Array.from({ length: end - start + 1 }, (_, index) => start + index);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);


  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const YourComponent = ({ job, index }) => {


    return (
      <tr key={index}>
        <td style={{ paddingLeft: '15px', textAlign: 'end' }}>{index + 1}</td>
        <td >
          {job.client_category ? <Link to={`/jobdetails?id=${job.job_id}&category=${job.client_category}`} style={{ textDecoration: 'none', color: 'blue' }}>
            {job.job_name} </Link>:
           <Link to={`/jobdetails?id=${job.job_id}&category=TECHNOLOGY`} style={{ textDecoration: 'none', color: 'blue' }}>
              {job.job_name} </Link>}
        </td>
        <td>{job.job_rec_id}</td>
        <td>{job.client_name}</td>
     
        <td style={{textTransform:'capitalize'}}>{job?.client_category?.toLowerCase()}</td>

        <td style={{ textAlign: 'end' }}>{job.openings_count}</td>
        <td>
          <div style={{ display: 'flex', flexDirection: 'row', margin: '0px' }}>
            <div className="col-6 col-md-6" style={{ borderRight: '1px solid #8080803d', textAlign: 'end' }}>
              {job.interviews_total}
            </div>
            <div className=' col-6 col-md-6' style={{ textAlign: 'end' }}>
              {job.interviews_done}
            </div>
          </div>
        </td>
     


      </tr>
    );
  };


  return (
    <div className='dashboard-div ' style={{ overflowX: 'hidden' }}>
      <AdminNavHeader></AdminNavHeader>
      <div className=''>

        <div className='page-title-heading'></div>
       
        {jobFlag && (
          <div className='row'>
            <div className='col-lg-3 col-md-9 col-9'>
              <Form onSubmit={handleSearch}>
                <div className='list-tech-div' style={{ marginLeft: '50px', padding: '0px', marginRight: '20px', marginBottom: '10px' }}>
                  <Form.Group style={{ height: '30px' }} className='input-width'>
                    <Form.Control type="text" placeholder=" Search by job name...." value={searchTerm} onChange={(e) => { setSearchTerm(e.target.value);console.log("event",e.target.value); if (e.target.value.length === 1 || e.target.value.length === 0) {console.log("filtered@",filteredData); setFilteredData(searchData) } }} style={{ background: 'white', padding: '4px' }} />
                  </Form.Group>
                  <Button type="submit" className='tech-submit' variant='dark' style={{ marginLeft: '5px', width: '80px', padding: '4px' }} onSubmit={handleSearch}> Search</Button>
                </div>
              </Form>
            </div>
     
            <div className='col-lg-2 col-md-4 col-12 col-sm-4' style={{ textAlign: 'end',marginBottom:'10px' }}>
              <label htmlFor="dropdown" style={{padding:'5px'}}>Jobs per Page:</label>
              <select className='page-no-dropdown' id="dropdown" value={selectedPageCount} onChange={handleJobsPerPage}>
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="40">40</option>
                <option value="50">50</option>
                <option value="75">75</option>
                <option value="100">100</option>
              </select>
            </div>
            <div className='col-lg-3 col-md-4 col-12 col-sm-4'  style={{ textAlign: 'center',marginBottom:'10px' }}>
                      <button
                        onClick={() => paginate(currentPage - 1)}
                        className='page-nation-btn'
                        disabled={currentPage === 1}
                      >
                        Prev
                      </button>

                      {getPageRange().map((page) => (
                        <button
                          key={page}
                          onClick={() => paginate(page)}
                          className='page-nation-btn'
                          style={{
                            backgroundColor: page === currentPage ? '#007BFF' : 'white',
                            color: page === currentPage ? 'white' : 'black',
                          }}
                        >
                          {page}
                        </button>
                      ))}

                      <button
                        onClick={() => paginate(currentPage + 1)}
                        className='page-nation-btn'
                        disabled={currentPage === totalPages}
                      >
                        Next
                      </button>
                    </div>
            
           
          </div>)}
        {jobFlag && (
          <div className='tables-div'>
            <Row className='tables-div'>
              <Col>
                {success && <Alert variant="danger">{success}</Alert>}
                {loading && (
                  <div className="spinner-overlay">
                    <Spinner animation="border" role="status">
                      <span className="sr-only"></span>
                    </Spinner>
                  </div>
                )}
                {currentItems.length > 0 ? (
                  <div className="table-responsive">
                    <Table striped bordered hover>
                      <thead>
                        <tr style={{ backgroundColor: '#EDF2FB' }}>
                          <th style={{ textAlign: 'end', color: '#345687' }}>##</th>
                          <th onClick={() => toggleSortOrder('jobname')} style={{ cursor: 'pointer', color: '#345687' }} ><span style={{ display: 'flex' }}> <span style={{ flex: 'auto' }}>Job Name </span> <span>{sortOrder === 'asc' ? ' ▲' : ' ▼'} </span></span></th>
                          <th onClick={() => toggleSortOrder('jobid')} style={{ color: '#345687', cursor: 'pointer' }}><span style={{ display: 'flex' }}> <span style={{ flex: 'auto' }}>Job ID</span><span>{sortOrderById === 'asc' ? ' ▲' : ' ▼'}</span></span> </th>
                          <th onClick={() => toggleSortOrder('clientname')} style={{ width: '10%', color: '#345687',cursor:'pointer' }}><span style={{ display: 'flex' }}> <span style={{ flex: 'auto' }}> Client Name</span> <span>{sortOrderClient === 'asc' ? ' ▲' : ' ▼'}</span></span></th>


                          {/* <th style={{ width: 120, color: '#345687' }}>Questions</th> */}
                          <th style={{ width: 120, color: '#345687' }}>Category</th>
                          <th style={{ textAlign: 'end', color: '#345687' }}>Openings</th>
                          <th style={{ color: '#345687' }} className='text-center'>Skills Interviews <br />
                            <div style={{ display: 'flex', flexDirection: 'row', borderTop: '1px solid #8080803d', margin: '0px' }}>
                              <div className="col-6 col-md-6" style={{ borderRight: '1px solid #8080803d', color: '#345687' }}>Scheduled</div>
                              <div className="col-6 col-md-6" style={{ color: '#345687' }}>Completed</div>
                            </div>
                          </th>
                       
                        </tr>
                      </thead>
                      <tbody>
                        {currentItems.map((job, index) => (
                          <YourComponent key={indexOfFirstItem + index} job={job} index={indexOfFirstItem + index} />
                        ))}


                      </tbody>
                    </Table>
                    
                  </div>):(
                    <div>
                      { !loading && isCategory && <Alert variant="danger">No Data Available</Alert>}
                    </div>
                  )
                }
              </Col>
            </Row>
          </div>
        )}
  
      </div>
    </div>
  );

}
export default RegisteredCandidates;